import {
    optionTitle_appearance,
    optionSearch_appearance,
    optionSearchSchoolWeek_appearance,
} from './AppearanceOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
import { isEdu } from 'owa-nonboot-userconfiguration-manager';
let AppearanceOption: LazyOption = createLazyOption(
    {
        key: 'appearance',
        titleStringKey: optionTitle_appearance,
        searchTermsStringKey: isEdu() ? optionSearchSchoolWeek_appearance : optionSearch_appearance,
        allowedOptionKeys: ['CalendarAppearance'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default AppearanceOption;
